export const LOGGED_IN = 'logIn';
export const LOGGED_OUT = 'logOut';
export const FETCH_FEED_POSTS = 'fetchFeedPosts';
export const FETCH_USER_POSTS = 'fetchCurrentUserPosts';
export const LIKE_POST = 'likePost';
export const SAVE_POST = 'savePost';
export const UNLIKE_POST = 'unlikePost';
export const UNSAVE_POST = 'unsavePost';
export const FETCH_PROFILE_VIEW_POSTS = 'fetchProfileViewPosts';
export const FETCH_ALL_USERS = 'fetchAllUsers';